(function () {
  var PALETTE_SVG = '<svg width="15" height="15" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M16 2a14 14 0 1 0 0 28c1.5 0 2.5-1 2.5-2.3 0-.6-.25-1.15-.65-1.6-.4-.45-.65-1-.65-1.6 0-1.3 1-2.3 2.3-2.3H22a8 8 0 0 0 8-8c0-6.6-6.3-12-14-12z" fill="#F4F4F2" stroke="#151515" stroke-width="1.4"/>' +
    '<circle cx="10.5" cy="12.5" r="2.3" fill="#E0574C"/>' +
    '<circle cx="9" cy="19" r="2.3" fill="#3F7FBF"/>' +
    '<circle cx="15" cy="23" r="2.3" fill="#E8B23D"/>' +
    '<circle cx="21.5" cy="11" r="2.3" fill="#4E9B5D"/>' +
    '<circle cx="16.5" cy="7" r="2.3" fill="#8C5CC4"/>' +
    '</svg>';

  var MAX_ATTEMPTS = 6;
  var RETRY_DELAY_MS = 400;

  function tryFinalize(card, attempt) {
    var swatch = card.querySelector('.mpg-swatch');
    var count = swatch ? swatch.querySelectorAll('.mpg-swatch__option').length : 0;

    if (count >= 1) {
      swatch.style.display = 'none';
      var badge = card.querySelector('.design-badge');
      var label = count === 1 ? '1 Design' : ('+' + count + ' Designs');
      badge.innerHTML = PALETTE_SVG + '<span>' + label + '</span>';
      card.dataset.designBadgeDone = 'true';
      return;
    }
    if (swatch) swatch.style.display = 'none';

    if (attempt < MAX_ATTEMPTS) {
      setTimeout(function () { tryFinalize(card, attempt + 1); }, RETRY_DELAY_MS);
    } else {
      // No group data ever showed up -- leave the badge slot empty (still reserves
      // its space via CSS min-height) rather than waiting forever.
      card.dataset.designBadgeDone = 'true';
    }
  }

  function processCard(card) {
    if (card.dataset.designBadgeInserted) return;
    var price = card.querySelector('.product-card-info .price');
    if (!price || !price.parentElement) return;
    card.dataset.designBadgeInserted = 'true';

    var badge = document.createElement('div');
    badge.className = 'design-badge';
    price.parentElement.insertBefore(badge, price.nextSibling);

    tryFinalize(card, 0);
  }

  function scan() {
    document.querySelectorAll('.product-card').forEach(processCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var observer = new MutationObserver(function () {
    scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
